import { IFieldMetaData } from "./IField"
import { comparisionValues } from "./IValidationRule"

export interface ILegacyDuTypeFormField {
  containerType: IFieldMetaData
  containerName: IFieldMetaData
  description: IFieldMetaData
  customerType: IFieldMetaData
  isDefault: IFieldMetaData
}
//ILegacyDuTypeFormField
export const FIELDS: ILegacyDuTypeFormField = {
  containerType: { name: "containerType", rules: { alphanumeric: {} } },
  containerName: { name: "containerName", rules: { alphanumeric: {} } },
  description: { name: "description", rules: { alphanumeric: {} } },
  customerType: { name: "customerType", rules: { required: {} } },
  isDefault: { name: "isDefault", rules: {} },
}

export const ERROR_MESSAGES = {
  required: "This field is required",
  decimal: "This field only takes decimal values",
  alphanumeric: "This field only takes alphanumeric values",
  integer: (value: string | number) =>
    `Entered value (e.g. ‘${value}’) is not an integer.`,
  inputRange: (
    lowerLimit: number | undefined,
    upperLimit: number | undefined,
    unit: string | undefined = "",
    comparision?: comparisionValues
  ) => {

    switch (comparision) {
      case "greater":
        {
          return `Value must be greater than ${lowerLimit}${unit}`;
        }
      default:
        {
          return `Value must be greater than or equal to ${lowerLimit}${unit} and less than or equal to ${upperLimit}${unit}`;
        }
    }
  },
}

export enum FormInputLevels {
  LEGACYCONTAINERTYPE = "Container Type",
  LEGACYCONTAINERTNAME = "Container Name",
  LEGACYDESCRIPTION = "Container Description",
  CUSTOMERTYPE = "Customer Type",
  IS_DEFAULT = "Preferred"
}

export interface ILegacyTypeError {
  containerType: string | undefined
  containerName: string | undefined
  description: string | undefined
  customerType: string | undefined
  isDefault: string | undefined
}

export const CustomerTypeOptions = [
  { label: "Warehouse", value: "Warehouse" },
  { label: "Store", value: "Store" },
  //{ label: "Both (Depot & Store)", value: "Both" }
];